export enum QAQCStatusEnum {
	ACTIVE = 'ACTIVE',
	CANCELLED = 'CANCELLED'
}

export enum QAQCStatusLabelEnum {
	ACTIVE = 'Ativo',
	CANCELLED = 'Cancelado'
}
